export class MembershipDTO {
  policyId: number;
  personId: number;
  memberNo: string; // a.k.a. policy number
  dependentNo: string; // memberNo + dependentNo = cardholderNumber
  beneficiaryNationalIdNumber: string;
}
